module.exports = __webpack_public_path__ + "static/1350164916.a031a8cd.jpg";